import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isSearch", "isCompact"];
import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box } from '@atlaskit/primitives/compiled';
import { EditorThemeContext, useEditorTheme, useEditorThemeContext } from '../../hooks/use-editor-theme';
import { splitTextByNewLine } from '../../utils/split-text-by-new-line';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { ReadOnlyControlsContent } from '../jql-editor-controls-content/read-only-controls-content';
import { EditorControls, EditorFooter, EditorMain, EditorView, EditorViewContainer, LineNumberToolbar, ReadOnlyEditorView, ReadOnlyEditorViewContainer } from './styled';
var JQLEditorLayout = function JQLEditorLayout(props) {
  var _useEditorThemeContex = useEditorThemeContext(),
    defaultMaxRows = _useEditorThemeContex.defaultMaxRows,
    expandedRows = _useEditorThemeContex.expandedRows,
    isSearch = _useEditorThemeContex.isSearch,
    isCompact = _useEditorThemeContex.isCompact;
  var editorViewHasFocus = props.editorViewHasFocus,
    EditorControlsContent = props.EditorControlsContent,
    EditorFooterContent = props.EditorFooterContent,
    editorViewIsInvalid = props.editorViewIsInvalid,
    lineNumbersVisible = props.lineNumbersVisible,
    mainId = props.mainId,
    onEditorMainRef = props.onEditorMainRef,
    onEditorViewContainerRef = props.onEditorViewContainerRef,
    onEditorViewContainerScroll = props.onEditorViewContainerScroll,
    onEditorViewRef = props.onEditorViewRef,
    onEditorViewBlur = props.onEditorViewBlur,
    onEditorViewFocus = props.onEditorViewFocus,
    onEditorViewTransitionEnd = props.onEditorViewTransitionEnd;
  return /*#__PURE__*/React.createElement(EditorMain, {
    id: mainId,
    ref: onEditorMainRef
  }, /*#__PURE__*/React.createElement(EditorViewContainer, {
    editorViewHasFocus: editorViewHasFocus,
    editorViewIsInvalid: editorViewIsInvalid,
    ref: onEditorViewContainerRef,
    onScroll: onEditorViewContainerScroll
  }, /*#__PURE__*/React.createElement(LineNumberToolbar, {
    lineNumbersVisible: lineNumbersVisible
  }), /*#__PURE__*/React.createElement(EditorView, {
    defaultMaxRows: defaultMaxRows,
    expandedRows: expandedRows,
    isCompact: isCompact,
    lineNumbersVisible: lineNumbersVisible,
    ref: onEditorViewRef,
    onBlur: onEditorViewBlur,
    onFocus: onEditorViewFocus,
    onTransitionEnd: onEditorViewTransitionEnd
  }), /*#__PURE__*/React.createElement(EditorControls, {
    isSearch: isSearch,
    isCompact: isCompact,
    isVisualRefresh: fg('platform-component-visual-refresh')
  }, EditorControlsContent)), /*#__PURE__*/React.createElement(EditorFooter, null, EditorFooterContent));
};
/**
 * A read only version of the JQL Editor which mimics the layout of the complete component, suitable as an intermediary
 * state when rendering the editor asynchronously.
 * In order to minimise bundle size impact on consumers, it is critical that this component (and any child component)
 * only imports the bare minimum dependencies required to replicate the editor layout.
 */
var JQLEditorReadOnlyWithoutTheme = function JQLEditorReadOnlyWithoutTheme(_ref) {
  var query = _ref.query;
  var _useEditorThemeContex2 = useEditorThemeContext(),
    defaultMaxRows = _useEditorThemeContex2.defaultMaxRows,
    expandedRows = _useEditorThemeContex2.expandedRows,
    isSearch = _useEditorThemeContex2.isSearch,
    isCompact = _useEditorThemeContex2.isCompact;
  var blocks = splitTextByNewLine(query);
  var lineNumbersVisible = blocks.length > 1;
  return /*#__PURE__*/React.createElement(EditorMain, null, /*#__PURE__*/React.createElement(ReadOnlyEditorViewContainer, null, /*#__PURE__*/React.createElement(LineNumberToolbar, {
    lineNumbersVisible: lineNumbersVisible
  }), /*#__PURE__*/React.createElement(ReadOnlyEditorView, {
    "data-testid": "jql-editor-read-only",
    role: "combobox",
    "aria-readonly": true,
    defaultMaxRows: defaultMaxRows,
    expandedRows: expandedRows,
    lineNumbersVisible: lineNumbersVisible,
    isCompact: isCompact
    // aria-expanded and aria-controls here are placeholders only. This is to avoid a11y violations.
    // This component JQLEditorReadOnlyWithoutTheme is only a loading state
    // Therefore the autocomplete combobox is never shown to the users
    ,
    "aria-expanded": false,
    "aria-controls": "dummy-jql-editor-auto-complete-id",
    "aria-label": "JQL query"
  }, blocks.map(function (block, index) {
    return /*#__PURE__*/React.createElement(Box, {
      as: "p",
      key: index
    }, block);
  })), /*#__PURE__*/React.createElement(EditorControls, {
    isSearch: isSearch,
    isCompact: isCompact
  }, /*#__PURE__*/React.createElement(ReadOnlyControlsContent, null))), /*#__PURE__*/React.createElement(EditorFooter, null));
};
export var JQLEditorReadOnly = function JQLEditorReadOnly(_ref2) {
  var isSearch = _ref2.isSearch,
    isCompact = _ref2.isCompact,
    props = _objectWithoutProperties(_ref2, _excluded);
  var editorTheme = useEditorTheme({
    isSearch: isSearch,
    isCompact: isCompact
  });
  return /*#__PURE__*/React.createElement(EditorThemeContext.Provider, {
    value: editorTheme
  }, /*#__PURE__*/React.createElement(JQLEditorReadOnlyWithoutTheme, props));
};
export default JQLEditorLayout;